var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomePort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#109B32",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.794 12.326c.593.477.942 1.195.95 1.957l-.008 6.644a3.268 3.268 0 0 1-3.268 3.269h-1.45a1.587 1.587 0 0 1-1.586-1.58v-3a.42.42 0 0 0-.42-.42h-2.174a.42.42 0 0 0-.42.427v1.145a.652.652 0 0 1-1.305 0v-1.145a1.732 1.732 0 0 1 1.732-1.732h2.174a1.732 1.732 0 0 1 1.724 1.732v2.993c0 .152.124.275.276.275h1.485c1.08 0 1.957-.876 1.957-1.956v-6.638a1.225 1.225 0 0 0-.464-.942L16.99 9.362a1.71 1.71 0 0 0-2.174 0l-1.609 1.203a.665.665 0 0 1-.775-1.08l1.587-1.152a3.007 3.007 0 0 1 3.768 0l5.007 3.993ZM11.352 22.884h3.333v.014a.652.652 0 0 1 0 1.305h-3.333a3.275 3.275 0 0 1-3.268-3.268v-6.638a2.522 2.522 0 0 1 .978-1.957l.602-.449a.652.652 0 0 1 .753 1.037l-.587.434c-.278.231-.44.573-.442.935v6.63a1.971 1.971 0 0 0 1.964 1.957Z",
    fill: "#004800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePort);
export default __webpack_public_path__ + "static/media/home-port.784559081dc51cabfb28912fb3327c0a.svg";
export { ForwardRef as ReactComponent };